import { IdTokenClaims } from '../../models';

export interface State {
  idTokenClaims: IdTokenClaims;
  isActiveAccountSet: boolean;
  error: string | null;
  loading: boolean;
  loaded: boolean;
  idpCode: string;
  redirectState: string;
  lastVerifiedUserGuid: string;
  verifiedUserGuids: string[];
}

export const initialState: State = {
  idTokenClaims: null,
  isActiveAccountSet: false,
  error: null,
  loading: false,
  loaded: false,
  idpCode: null,
  redirectState: null,
  lastVerifiedUserGuid: null,
  verifiedUserGuids: [],
};
